import React, { useContext } from 'react';
import NavbarKey from '../components/nav/NavBarKey'
import UserProvider from '../context/UserContext'

import _ from "lodash";
import MainPayment from '../components/mains/MainPayment'
import MainOOS from '../components/mains/MainOOS';
import MainSuccess from '../components/mains/MainSuccess'
import MainLost from '../components/mains/MainLost'
import MainBanned from '../components/mains/MainBanned'

const urlquery = window.location.search;
const urlParams = new URLSearchParams(urlquery);
var password  = urlParams.get('password')

if(password == "undefined"){
    password = ""
}
else if(password == undefined){
    password = ""
}

const Restock = () => {
    const Data = useContext(UserProvider.context);
    const userData = Data.user
    const isStock = Data.stock
    const Logged = !_.isEmpty(userData);
    const isSuccess = Data.success
    const isLoaded = !(Data.loading);
    const isPassword = Data.password
    const isBanned = Data.banned

    return (
        <div className="parent">
            {
                isLoaded && 
                Logged &&
                isSuccess &&
                isPassword &&
                !isBanned && 
                <div className="parent">
                    <div id="overlay" className="overlay">
                        <div className="opacity">
                        </div>
                    </div>
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main">
                        <MainSuccess/>
                    </div>
                </div>
            }
            {
                isLoaded && 
                Logged &&
                isStock &&
                !isSuccess &&
                isPassword &&
                !isBanned &&
                <div className="parent">
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main">
                        <MainPayment/>
                    </div>
                </div>
            }
            {
                isLoaded && 
                Logged &&
                !isStock &&
                !isSuccess &&
                isPassword &&
                !isBanned &&
                <div className="parent">
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main container">
                        <MainOOS/>
                    </div>
                </div>
            }
            {
                isLoaded && 
                Logged &&
                !isPassword &&
                isBanned &&
                <div className="parent">
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main container">
                        <MainBanned/>
                    </div>
                </div>
            }
            {
                isLoaded && 
                Logged &&
                !isPassword &&
                !isBanned &&
                <div className="parent">
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main container">
                        <MainLost/>
                    </div>
                </div>
            }
            {
                isLoaded && 
                !Logged &&
                password &&
                window.location.replace(`${process.env.REACT_APP_API_URL}/discord-auth/?password=` + password)
            }
            {
                isLoaded && 
                !Logged &&
                !password &&
                window.location.replace(`${process.env.REACT_APP_API_URL}/discord-auth/?password=` + password)
            }
        </div>
    )
};


export default Restock;